import type { ReactNode } from 'react';
import React, { createContext, useMemo, useState } from 'react';

import type { RenderingSelectionContext } from 'src/modules/renderings/provider/types';
import type {
  HiDefRendering,
  HiDefRenderingFile,
} from 'src/shared/graphql/generated';

export const renderingSelectionContext =
  createContext<RenderingSelectionContext>({
    setRendering: () => undefined,
    setRenderingFile: () => undefined,
  });

export const RenderingSelectionProvider = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const [rendering, setRendering] = useState<HiDefRendering | undefined>();
  const [renderingFile, setRenderingFile] = useState<
    HiDefRenderingFile | undefined
  >();

  const contextValue = useMemo(
    () => ({
      rendering,
      setRendering,
      renderingFile,
      setRenderingFile,
    }),
    [rendering, setRendering, renderingFile, setRenderingFile],
  );

  return (
    <renderingSelectionContext.Provider value={contextValue}>
      {children}
    </renderingSelectionContext.Provider>
  );
};
